export const isEmpty = (s: string) => {
  return !s || s.trim().length === 0;
};
